import { createContext, type PropsWithChildren, useRef } from 'react';

import { createHttpClient, HttpService } from '@storebrand-digital/bank-foundation-http-service';

import auth from '../../auth';

export const HttpServiceContext = createContext<HttpService | null>(null);

export function HttpServiceProvider({ children }: PropsWithChildren) {
  const httpService = useRef(
    new HttpService(
      createHttpClient({
        baseUrl: window.env.WEB_API_ROOT,
        clientId: window.env.CLIENT_ID,
        tokenProvider: async () => {
          const token = await auth.getToken();
          if (!token) {
            throw new Error('No token was returned. Please refresh and try again');
          }

          return token;
        },
        correlationIdProvider: () => crypto.randomUUID(),
      })
    )
  );

  return <HttpServiceContext.Provider value={httpService.current}>{children}</HttpServiceContext.Provider>;
}
